import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
export const FaqSection = () => {
  const faqs = [{
    q: '¿Cómo recibo el pack después de comprar?',
    a: 'Al completar el pago recibís un email automático con el link de descarga. Acceso inmediato en menos de 5 minutos. Los archivos son PDF listos para abrir, imprimir o usar en tablet.'
  }, {
    q: '¿Para qué nivel Cambridge sirve?',
    a: 'El pack cubre Cambridge Starters y Movers (Módulo 1, Ages 6-11), KET A2 y PET B1 (Módulo 2, Ages 12-17) y gramática de A1 a B1 (Módulo 3). Sirve como preparación y como repaso.'
  }, {
    q: '¿Necesito saber inglés para usarlo?',
    a: 'No. Ese es el punto central del producto. Cada página de actividad en inglés tiene su página espejo en español. El padre puede acompañar, corregir y practicar con su hijo/a sin saber inglés.'
  }, {
    q: '¿Los 3 bonos están incluidos siempre?',
    a: 'Sí. Los 3 bonos están incluidos en todas las compras del pack. No hay versión sin bonos. No es una oferta temporal.'
  }, {
    q: '¿Funciona si mi hijo/a va a un colegio bilingüe o a una academia de inglés?',
    a: 'Sí. El pack complementa cualquier institución de enseñanza. Está diseñado para practicar en casa lo que se aprende en el instituto.'
  }, {
    q: '¿Puedo imprimirlo?',
    a: 'Sí. Todos los archivos están optimizados para impresión en A4. También funcionan perfectamente en tablet, computadora o celular.'
  }, {
    q: '¿Es diferente a un libro Cambridge oficial?',
    a: 'Completamente diferente. Los libros Cambridge están solo en inglés. Este pack tiene todo en inglés para el alumno Y en español para la familia. Nadie más hace esto en Argentina.'
  }, {
    q: '¿Para qué edades sirve exactamente?',
    a: 'Módulo 1: 6 a 11 años (Cambridge Starters/Movers). Módulo 2: 12 a 17 años (KET A2 / PET B1). Módulo 3: Cualquier edad (Gramática A1-B1).'
  }, {
    q: '¿Qué métodos de pago aceptan?',
    a: 'Tarjeta de crédito y débito, Mercado Pago, Ualá y transferencia bancaria. Pago 100% seguro.'
  }, {
    q: '¿Tiene garantía real?',
    a: 'Sí. 7 días de garantía total. Si no quedás satisfecho/a con el pack, te devolvemos el dinero completo. Sin preguntas ni formularios.'
  }, {
    q: '¿Es compatible con el programa del colegio de mi hijo/a?',
    a: 'Sí. El contenido está alineado con los niveles Cambridge oficiales que se usan en todos los institutos de Argentina.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="bg-familia-section py-10 md:py-16 px-4 md:px-6" data-id="element-68">
      <div className="max-w-3xl mx-auto w-[92%] md:w-full" data-id="element-69">
        <h2 className="text-[22px] sm:text-3xl md:text-4xl font-display font-bold text-center mb-8 md:mb-12" data-id="element-70">
          ❓ PREGUNTAS FRECUENTES
        </h2>

        <div className="space-y-2 md:space-y-4" data-id="element-71">
          {faqs.map((faq, i) => {
          const isOpen = openIndex === i;
          return <div key={i} className={`border rounded-xl overflow-hidden transition-all duration-300 ${isOpen ? 'border-familia-cyan bg-familia-card' : 'border-familia-cyan/25 bg-familia-bg'}`} data-id="element-72">
                <button onClick={() => setOpenIndex(isOpen ? null : i)} className="w-full px-4 md:px-6 py-3 md:py-5 text-left flex justify-between items-center gap-3" data-id="element-73">
                  <span className="font-bold text-[14px] sm:text-base" data-id="element-74">
                    {faq.q}
                  </span>
                  <span className={`text-familia-cyan text-2xl transition-transform duration-300 shrink-0 ${isOpen ? 'rotate-45' : ''}`} data-id="element-75">
                    +
                  </span>
                </button>
                <AnimatePresence data-id="element-76">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} data-id="element-77">
                      <div className="px-4 md:px-6 pb-4 md:pb-6 pt-2 text-familia-gray text-[14px] sm:text-base leading-relaxed border-t border-white/10" data-id="element-78">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
};